import { COLORS } from '@/ui-library/design-system';
import { Flex } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { components } from 'react-select';

export const SchInterviewerMultiValueContainer = (props) => {
  const { interviewDataRef, data, registerForUpdates, ...otherProps } = props;
  const { value } = data || {};
  const { colorCodes } = interviewDataRef?.current || {};
  const { light } = colorCodes?.[value] || COLORS?.['pastel-1'];

  const { userCalendarInfo } = interviewDataRef?.current || {};
  const isUserCalendarConnected =
    userCalendarInfo?.[value]?.isCalendarConnected;

  const [, forceUpdate] = useState({});

  useEffect(() => {
    const unregisterColorCodes = registerForUpdates('colorCodes', () => {
      forceUpdate({});
    });

    const unregisterUserCalendarInfo = registerForUpdates(
      'userCalendarInfo',
      () => {
        forceUpdate({});
      }
    );

    return () => {
      unregisterColorCodes();
      unregisterUserCalendarInfo();
    };
  }, [registerForUpdates]);

  const showCalendarNotConnected = isUserCalendarConnected === false;

  return (
    <components.MultiValueContainer {...props}>
      <Flex
        style={{
          background: showCalendarNotConnected ? 'secondary-100' : light,
          border: showCalendarNotConnected && '1px solid #6D659D',
          maxWidth: '100%',
          overflow: 'hidden',
          borderRadius: '6px',
        }}
      >
        {otherProps?.children}
      </Flex>
    </components.MultiValueContainer>
  );
};
